module.exports = __webpack_public_path__ + "img/15.c632f9a1.jpg";